import React from "react";
import { Pricing } from "../../components";

const Services = () => {
  return (
    <>
      <Pricing />
    </>
  );
};

export default Services;
